import gql from 'graphql-tag';

const UPDATE_COMMENT_ON_DEVICE = gql`
  mutation updateCommentOnDevice($commentId: String!, $note: String, $imageAttachments: [String]) {
    updateCommentOnDevice(commentId: $commentId, note: $note, imageAttachments: $imageAttachments) {
      code
      comment {
        deviceSerialNo
        createdBy
        updatedOn
        fromStage
        toStage
        imageAttachments
        _id
        note
        creatorName
        createdOn
      }
    }
  }
`;

export default UPDATE_COMMENT_ON_DEVICE;
